/**
 * Copy-to-clipboard for the discount code on "Available offers" product blocks.
 * Delegated from the document so it keeps working when the theme editor
 * re-renders the product section.
 */
(function () {
  if (window.themeProductOffersInit) return;
  window.themeProductOffersInit = true;

  var RESET_DELAY = 2000;

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();

      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (e) {
        reject(e);
      }

      document.body.removeChild(input);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-offer-code]');
    if (!button) return;

    event.preventDefault();

    var code = button.getAttribute('data-offer-code');
    var output = button.querySelector('[data-offer-code-text]');
    if (!code || !output || button.classList.contains('is-copied')) return;

    copy(code)
      .then(function () {
        button.classList.add('is-copied');
        output.textContent = button.getAttribute('data-offer-code-copied') || code;

        setTimeout(function () {
          button.classList.remove('is-copied');
          output.textContent = code;
        }, RESET_DELAY);
      })
      .catch(function () {});
  });
})();
